import { PaginatedAgentsPayload } from 'app/modules/agents/requests';

const BASE = ['agents'] as const;

export const AGENT_QUERY_KEYS = {
  getAllAgents: () => [...BASE, 'agents'] as const, //  For invalidation purposes
  getAgents: (payload: PaginatedAgentsPayload) =>
    [...AGENT_QUERY_KEYS.getAllAgents(), payload] as const,
  getAgent: (id?: number) => [...BASE, 'agent', id] as const,
  getAgentSearch: (payload?: PaginatedAgentsPayload) =>
    payload
      ? ([...BASE, 'search', payload] as const)
      : ([...BASE, 'search'] as const),
  getAgentShort: (id: number) => [...BASE, 'agent-short', id] as const,
};
